import Lockr from 'lockr';
// import * as types from '../mutation-types';

const app = {
  state: {
    sidebar: {
      opened: !+Lockr.get('sidebarStatus'), // !+Lockr.get('sidebarStatus')
      withoutAnimation: false
    },
    language: Lockr.get('language') || 'en'
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Lockr.set('sidebarStatus', 1);
      } else {
        Lockr.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Lockr.set('sidebarStatus', 1);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      Lockr.set('language', language);
    }
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR');
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation);
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language);
    }
  }
};

export default app;
